// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".docs-callout[data-v-6d893fb4]{border-radius:10px}.docs-callout--dark[data-v-6d893fb4]{border-color:rgba(150,214,255,.34) !important;background-color:rgba(8,23,37,.66);color:rgba(234,246,255,.92) !important}.docs-callout--dark[data-v-6d893fb4] .v-alert__content{color:inherit}", ""]);
// Exports
module.exports = exports;
